module.exports = __webpack_public_path__ + "static/img/img_gy_e_h.9cc142a8.png";